import { useEffect, useMemo, useRef } from "react";
import debounce from "lodash.debounce";
import { Search } from "../Icons/general-interface-1";
import { RefreshCw } from "../Icons/arrows";
import styles from "./index.module.scss";

type PropsType = {
  onChange: (value: string) => void;
  placeholder?: string;
  loading?: boolean;
};

const SearchInput = ({ onChange, placeholder, loading }: PropsType) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleChange = useMemo(
    () =>
      debounce(() => {
        if (inputRef.current) {
          onChange(inputRef.current.value);
        }
      }, 500),
    [onChange]
  );
  useEffect(() => () => handleChange.cancel(), [handleChange]);

  return (
    <div className={styles.inputContainer}>
      <input
        id="search-filter"
        ref={inputRef}
        type="text"
        onChange={handleChange}
        className={styles.input}
        placeholder={placeholder}
      />
      {loading ? (
        <RefreshCw className={styles.iconLoading} />
      ) : (
        <Search className={styles.icon} />
      )}
    </div>
  );
};

export default SearchInput;
